import { SubscriptionsStatsParams } from '@partoohub/api-client';
import { useQuery } from 'react-query';

import { businessApiClient } from 'app/api/v2/api_calls/apiResources';
import { BUSINESS_SUBSCRIPTIONS } from 'app/common/data/queryKeysConstants';

/**
 * To be only used in AppData
 * If you need to use it in a component, use useSubscriptions instead
 */
export const useSubscriptionsQuery = (params: SubscriptionsStatsParams = {}) => {
    return useQuery([BUSINESS_SUBSCRIPTIONS, { params }], () =>
        businessApiClient.getSubscriptions(params),
    );
};
